<template>
    <div>
        <div class="row">
            <div class="col-4">
                <div class="mb-3">
                    <label class="form-label">Field Type <span class="text-danger">*</span></label>
                    <div class="d-inline-flex w-100">
                        <v-select :options="applicationFieldTypes == null ? [] : applicationFieldTypes" class="vselect w-100" placeholder="Choose Type" v-model="applicationFieldData.type"></v-select>
                        <button type="button" class="btn btn-secondary ms-1" @click="getApplicationFieldTypes('created', true)"><i class="bi bi-arrow-clockwise"></i></button>
                    </div>
                </div>
            </div>
            <div class="col-4">
                    <div class="mb-3">
                        <label class="form-label">Dependecies <span class="text-danger">*</span></label>
                        <div class="d-inline-flex w-100">
                            <vue-multi-select style="width: 100%; text-align: start" ref="multiSelect2" v-model="selecedDependencies" @input="onChangeInput" :options="options" :filters="filters" :btnLabel="btnLabel" :selectOptions="applicationFields">
                            </vue-multi-select>
                        <button type="button" class="btn btn-secondary ms-1" @click="getApplicationFieldsByApplicationId"><i class="bi bi-arrow-clockwise"></i></button>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-if="applicationFieldData.type == 'spinner' || applicationFieldData.type == 'radio' || applicationFieldData.type == 'toggle' || applicationFieldData.type == 'checkbox'">
            <div class="col-4">
                <div class="mb-3">
                    <label class="form-label" for="applicationFieldJson">Texts With Values <span
                            class="text-danger">*</span></label>
                    <input class="form-control" type="file" id="applicationFieldJson"
                        v-on:change="(e) => onJSONFileChange(e)">
                </div>
            </div>
            <div class="col-4" v-if="applicationFieldData.type == 'spinner'">
                <div class="mb-3">
                    <label class="form-label">Prompt <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" v-model="applicationFieldData.spinnerPrompt" />
                </div>
            </div>
            <div class="col-4" v-if="applicationFieldData.type == 'radio'">
                <div class="mb-3">
                    <label class="form-label">Span Count <span class="text-danger">*</span></label>
                    <input type="number" class="form-control" v-model="applicationFieldData.radioSpanCount" />
                </div>
            </div>
            <div class="col-4" v-if="applicationFieldData.type == 'checkbox'" style="margin: auto 0">
                <div class="mb-3 form-check">
                    <input type="checkbox" class="form-check-input" id="applicationFieldStylePopup" v-model="applicationFieldData.checkboxStylePopup">
                    <label class="form-check-label" for="applicationFieldStylePopup"> Style Popup<span class="text-danger">*</span></label>
                </div>
            </div>
            <div class="col-12">
                <div class="mb-3">
                    <textarea class="form-control" rows="5" style="resize: none; width: 50%" v-model="applicationFieldData.applicationFieldTextValueString" disabled />
                </div>
            </div>
        </div>
        <FieldInputTypeData v-if="applicationFieldData.type == 'text' || applicationFieldData.type == 'phone' || applicationFieldData.type == 'numeric' || applicationFieldData.type == 'decimal'" :applicationFieldData="applicationFieldData" />
        <div class="row" v-if="applicationFieldData.type == 'date' || applicationFieldData.type == 'datetime'">
            <div class="col-4">
              <div class="mb-3">
                <label class="form-label">Format <span class="text-danger">*</span></label>
                <input type="text" class="form-control" v-model="applicationFieldData.dateFormat" />
              </div>
            </div>
        </div>
    </div>
</template>

<script>
import vueMultiSelect from 'vue-multi-select';
import 'vue-multi-select/dist/lib/vue-multi-select.css';
import FieldInputTypeData from './FieldInputTypeData.vue';
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
export default {
    components: {
        vueMultiSelect,
        FieldInputTypeData,
        vSelect
    },
    props:{
        applicationFieldTypes: Array,
        applicationFieldData: Object,
        applicationFields: Array,
        getApplicationFieldTypes: Function,
        getApplicationFieldsByApplicationId: Function,
    },
    data() {
        return {
            btnLabel: values => `Select (${values.length})`,
            filters: [{
                nameAll: 'Select all',
                nameNotAll: 'Deselect all',
                func() {
                    return true;
                },
            }],
            options: {
                multi: true,
                groups: false,
                labelName: "title",
                labelValue: "id",
                cssSelected: option => (option.selected ? { 'color': '#E40046' } : ''),
            },
            selecedDependencies: this.applicationFieldData==null || this.applicationFields==null?[]:this.applicationFields.filter(s=>this.applicationFieldData.dependencies.includes(s.id)),
        }
    },
    watch: {
        'applicationFieldData.id'(newValue){
            this.selecedDependencies= this.applicationFieldData==null || this.applicationFields==null?[]:this.applicationFields.filter(s=>this.applicationFieldData.dependencies.includes(s.id));
        },
    },
    methods: {
        onChangeInput(value, id){
            this.applicationFieldData.dependencies = this.selecedDependencies.map(m => m.id)
        },
        onJSONFileChange(e) {
            var reader = new FileReader();
            reader.onload = (res) => {
                var result = res.target.result;
                var lines = result.split('\n');
                var listOfObj = []
                for (var i = 0; i < lines.length; i++) {
                var line = lines[i].slice(0, -1).split(/\s?,\s?/).map(item => item.split(':')).reduce((a, [key, val]) => Object.assign(a, { [key]: val }), {});
                listOfObj.push(line)
                }
                this.applicationFieldData.spinnerObject = listOfObj;
                this.applicationFieldData.applicationFieldTextValueString = result
            };
            reader.readAsText(e.target.files[0]);
        },
    }

}
</script>

<style></style>